import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  Optional,
  Renderer2,
} from '@angular/core';
import { TrackingSectionDirective } from './tracking-section.directive';
import { Tracking } from './tracking.service';

@Directive({
  selector: 'a, button, fl-button, input, fl-input, textarea, fl-link',
})
export class TrackingDirective implements AfterViewInit {
  @Input() flTrackingLabel: string;
  @Input() flTrackingExtraParams: { [k: string]: any };

  constructor(
    private element: ElementRef,
    private renderer: Renderer2,
    private t: Tracking,
    @Optional() private trackingSection: TrackingSectionDirective,
  ) {}

  ngAfterViewInit() {
    if (!this.trackingSection) {
      console.error(
        'Please provide an flTrackingSection for this view',
        this.element.nativeElement,
      );
      return;
    }
    if (!this.flTrackingLabel) {
      console.error(
        'Please provide an flTrackingLabel for this element',
        this.element.nativeElement,
      );
      return;
    }
    this.renderer.listen(
      this.element.nativeElement,
      this.tagToEvent(this.element.nativeElement.tagName),
      e => {
        this.t.track('user_action', {
          label: this.flTrackingLabel,
          section: this.trackingSection.flTrackingSection,
          action: e.type, // e.g., 'click'
          extra_params: this.flTrackingExtraParams,
        });
      },
    );
  }

  private tagToEvent(tagName: string): string {
    if (['INPUT', 'TEXTAREA'].includes(tagName)) {
      return 'focus, blur';
    }
    return 'click';
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/it/webapp/src/app/@shared/tracking/tracking.directive.ts